import { render, staticRenderFns } from "./editShopping.vue?vue&type=template&id=487cd224&scoped=true&"
import script from "./editShopping.vue?vue&type=script&lang=js&"
export * from "./editShopping.vue?vue&type=script&lang=js&"
import style0 from "./editShopping.vue?vue&type=style&index=0&id=487cd224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487cd224",
  null
  
)

export default component.exports